module.exports = __webpack_public_path__ + "vue/img/user_def.0be33b54.png";